import { get } from "./";
import { Query } from "../screens/Tickets/types";

export function dashboard(query: Query) {
  return get("tickets/dashboard", query);
}
